import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

/**
 * Menyetel judul tab browser (document.title) + favicon sesuai branding Yayasan
 * yang diatur di halaman "Pengaturan System".
 */
const PAGE_TITLES = {
  "/dashboard": "Dashboard Real-time",
  "/laporan-advertiser": "Laporan Advertiser",
  "/data-donasi": "Data Donasi",
  "/finance": "Finance",
  "/kampanye": "Kampanye",
  "/bank-transfer": "Bank Transfer",
  "/kelola-interest": "Kelola Interest",
  "/manajemen-program": "Kelola Program",
  "/manajemen-akun-iklan": "Kelola Akun Iklan",
  "/manajemen-user": "Kelola User",
  "/konten-iklan": "Konten Iklan",
  "/profil": "Profil Saya",
  "/pengaturan": "Pengaturan System",
  "/login": "Masuk",
};

let cachedName = null;

export default function BrandTitle() {
  const loc = useLocation();

  useEffect(() => {
    let alive = true;
    const apply = (nama) => {
      if (!alive) return;
      const brand = (nama || "").trim() || "Laporan Digital Marketing";
      const path = Object.keys(PAGE_TITLES).find((p) => loc.pathname.startsWith(p));
      document.title = path ? `${brand} · ${PAGE_TITLES[path]}` : brand;
    };

    if (cachedName !== null) {
      apply(cachedName);
    }
    api.get("/public/settings")
      .then((r) => {
        cachedName = r.data?.yayasan_nama || "";
        apply(cachedName);
        const logo = r.data?.logo_data;
        if (logo && typeof logo === "string" && logo.startsWith("data:image")) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
          }
          link.href = logo;
        }
      })
      .catch(() => apply(cachedName));

    return () => { alive = false; };
  }, [loc.pathname]);

  return null;
}
